// Overview's time window from the URL (consistency-pass spec §5): the same
// keys as Results, read through the same time chip. Overview has presets
// only, so it only ever loads a preset, and the one it loads is the one
// pressed: `submitted=all` is All time (whatever else the URL says), a chip
// equal to a preset is that preset, and anything else — a Submitted
// (instant) chip carried over from Results, another length, a value that
// doesn't parse — is the 30-day default.

import { ALL_TIME_KEY, DEFAULT_WITHIN, type Preset, presetOf } from "@/features/time/time-chip";

/** The preset Overview loads and presses for this URL. */
export function overviewPreset(search: Record<string, unknown>): Preset {
    if (search[ALL_TIME_KEY] === "all") return "all";
    return presetOf(search) ?? DEFAULT_WITHIN;
}

export function isAllTime(search: Record<string, unknown>): boolean {
    return overviewPreset(search) === "all";
}

/** The request's window: the preset's length, or none (all time). */
export function overviewWithin(search: Record<string, unknown>): string | undefined {
    const preset = overviewPreset(search);
    return preset === "all" ? undefined : preset;
}
